import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import SelfCareInvoicesBlockData from "../../../Models/Content/SelfCareInvoicesBlockData";
import SelfCareInvoicesMain from "./SelfCareInvoicesMain";

export default class SelfCareInvoicesBlock extends EpiComponent<SelfCareInvoicesBlockData> {

  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ["self-care-invoices-block"];
    return (
      <div className={cssClasses.join(" ")}>
        <SelfCareInvoicesMain context={this.getContext()} iContent={this.props.data} />
      </div>
    );
  }
}
